import React, { Component } from 'react';
import './dashboard.css';
import Header from '../header/header';
import firebaseInit from '../auth/firebaseInit';
import Navbar from '../navbar/navbar';
import Dashboards from '../pages/dashboards/dashboards';
import NewDashboard from '../pages/newDashboard/newDashboard';
import TaskBoard from '../pages/taskBoard/taskBoard';
import LoadingScreen from '../pages/loadingSceen/loadingScreen';

export default class Dashboard extends Component {
  style = {
    background: 'url("/images/bg.png")',
    backgroundPosition: '50%',
    backgroundRepeat: 'no-repeat',
    backgroundSize: 'cover',
    backgroundColor: '#ecf0f1',
    overflowX: 'hidden'
  };

  componentWillMount = () => {
    firebaseInit.auth().onAuthStateChanged(user => {
      this.setState({
        userDetails: {
          displayName: user.displayName,
          email: user.email,
          uid: user.uid
        }
      });
    });
  };

  getPageToRender = () => {
    switch (this.props.getRenderedPage()) {
      case 'dashboards':
        return (
          <Dashboards
            getAllDashboards={this.props.getAllDashboards}
            setRenderedPage={this.props.setRenderedPage}
            renderTaskBoard={this.props.renderTaskBoard}
          />
        );
      case 'newDashboard':
        return (
          <NewDashboard
            addNewDashboard={this.props.addNewDashboard}
            setRenderedPage={this.props.setRenderedPage}
          />
        );
      case 'taskBoard':
        return (
          <TaskBoard
            taskBoardToRender={this.props.taskBoardToRender}
            makeDashboardCopy={this.props.makeDashboardCopy}
            removeCurrentItem={this.props.removeCurrentItem}
            setRenderedPage={this.props.setRenderedPage}
            modifyExistingTask={this.props.modifyExistingTask}
            deleteExistingColumn={this.props.deleteExistingColumn}
            addTaskToColumn={this.props.addTaskToColumn}
            addNewColumn={this.props.addNewColumn}
            deleteExistingTask={this.props.deleteExistingTask}
          />
        );
      case 'loadingScreen':
      default:
        return <LoadingScreen />;
    }
  };

  render() {
    return (
      <div>
        <Navbar
          getRenderedPage={this.props.getRenderedPage}
          setRenderedPage={this.props.setRenderedPage}
        />
        <div className="dashboard" style={this.style}>
          <Header setRenderedPage={this.props.setRenderedPage} />
          <div className="page-container">{this.getPageToRender()}</div>
        </div>
      </div>
    );
  }
}
